(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Wand: iPhone mega menu — desktop tab switching (event delegation, no Dawn interference)
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.wand-iphone-mega__card');
    if (!card) return;
    var menu = card.closest('.wand-iphone-mega');
    if (!menu) return;

    menu.querySelectorAll('.wand-iphone-mega__card').forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-selected', 'false');
    });
    menu.querySelectorAll('.wand-iphone-mega__panel').forEach(function (p) {
      p.classList.remove('is-active');
    });

    card.classList.add('is-active');
    card.setAttribute('aria-selected', 'true');
    var panelId = card.getAttribute('aria-controls');
    if (panelId) {
      var panel = document.getElementById(panelId);
      if (panel) panel.classList.add('is-active');
    }
  });

  // Wand: iPhone mobile accordion — capture phase intercepts before Dawn's onCloseButtonClick
  // Dawn's MenuDrawer.bindEvents() attaches onCloseButtonClick to every <button> inside the
  // drawer, which would close the iPhone Cases submenu on trigger tap. Using capture:true here
  // means this listener fires before the event reaches the button, so stopPropagation() prevents
  // Dawn's handler from ever seeing the click.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.wand-iphone-mobile-menu__trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var item = trigger.closest('.wand-iphone-mobile-menu__item');
    if (!item) return;
    var isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  }, true);

  // Wand: hover-open for desktop mega menus
  // Only activates on pointer devices that support hover (mice, not touchscreens).
  // Setting [open] programmatically fires the native <details> toggle event, which
  // triggers HeaderMenu.onToggle() — so preventHide and --header-bottom-position-desktop
  // are set correctly, exactly as if the user had clicked.
  (function () {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;

    document.querySelectorAll('header-menu').forEach(function (hm) {
      var details = hm.querySelector('details.mega-menu');
      if (!details) return;
      var closeTimer;

      hm.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        // Close any other open mega menus first
        document.querySelectorAll('header-menu').forEach(function (other) {
          if (other === hm) return;
          var od = other.querySelector('details.mega-menu');
          if (od && od.hasAttribute('open')) od.removeAttribute('open');
        });
        details.setAttribute('open', '');
      });

      hm.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 150);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
